import { useAuth0 } from '@auth0/auth0-react';
import { ROUTES } from '@const';
import { Avatar, Box, ListItemText, Menu, MenuItem } from '@mui/material';
import { useCallback, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import yn from 'yn';
import { toggleOffAllLayers } from '../slice';
import { extractInitialsFromEmail } from '../utils';

const { VITE_DISABLE_AUTH } = import.meta.env;

export interface FlycasterAvatarProps {
  user: string;
  disablePopup?: boolean;
  // Height of the row the avatar sits in; the avatar is centred inside it.
  height?: number;
}
const FlycasterAvatar = ({ user, disablePopup, height = 64 }: FlycasterAvatarProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { logout } = useAuth0();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const disableAuth = yn(VITE_DISABLE_AUTH);

  const initials = useMemo(() => {
    return extractInitialsFromEmail(user);
  }, [user]);

  const handleClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    if (document.activeElement instanceof HTMLElement) document.activeElement.blur();

    setAnchorEl(null);
  }, []);

  const handleAdmin = useCallback(() => {
    dispatch(toggleOffAllLayers());
    navigate(ROUTES.ADMIN);
    handleClose();
  }, [dispatch, navigate, handleClose]);

  const handleSignOut = useCallback(() => {
    logout({
      logoutParams: {
        returnTo: window.location.origin
      }
    });
    handleClose();
  }, [handleClose, logout]);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignSelf: 'stretch',
          justifyContent: 'center',
          alignItems: 'center',
          height: `${height}px`
        }}
      >
        <Avatar variant="circular" sx={{ width: 32, height: 32, bgcolor: 'primary.main', cursor: disablePopup ? 'default' : 'pointer' }} onClick={handleClick}>
          {initials}
        </Avatar>
      </Box>

      {!disablePopup && (
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
        >
          <MenuItem onClick={handleAdmin}>
            <ListItemText>Admin</ListItemText>
          </MenuItem>
          {!disableAuth && (
            <MenuItem onClick={handleSignOut}>
              <ListItemText>Sign out</ListItemText>
            </MenuItem>
          )}
        </Menu>
      )}
    </>
  );
};
export default FlycasterAvatar;
